import { api } from '../api/client';
import type {
  RecipeImportRequest,
  RecipeImportResponse,
  RecipeImageStoreResponse,
} from '@familyhub/shared';
import type { CapturedImage } from './capture';

/**
 * Ask the server to parse a recipe from a photo/screenshots, a URL, or pasted
 * text. Online-only — it needs the model — and it writes nothing: the returned
 * draft is reviewed and saved through the module's own sync outbox.
 */
export function importRecipe(body: RecipeImportRequest): Promise<RecipeImportResponse> {
  return api<RecipeImportResponse>('/api/v1/recepten/import', { method: 'POST', body });
}

/**
 * Store a client-cropped image (the dish cut out of a screenshot) and get back
 * the same-origin path to display it from.
 */
export async function storeRecipeImage(image: CapturedImage): Promise<string> {
  const { path } = await api<RecipeImageStoreResponse>('/api/v1/recipe-images', {
    method: 'POST',
    body: image,
  });
  return path;
}
